import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { addNotification } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
import { SEARCH_REPORTS_FAILURE, SEARCH_REPORTS_REQUEST } from "../../../actions/types";
import { resetIsTriggerSearchReportState, searchReports } from "../../../actions";
import { reportsCenterErrorCodes } from "../../../config/errorCodeMessages";
export var searchReportsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(SEARCH_REPORTS_REQUEST), switchMap(function(action) {
        var _action_payload;
        return from(api.reportsCenterService.searchReports((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.reqPayload).pipe(mergeMap(function(response) {
            return of(resetIsTriggerSearchReportState(), searchReports.success(response));
        }), catchError(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return of(resetIsTriggerSearchReportState(), searchReports.failure(err), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: SEARCH_REPORTS_FAILURE,
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = reportsCenterErrorCodes[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "search_reports_notifications.failure" : "search_reports_notifications.failure",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default searchReportsEpic;

//# sourceMappingURL=index.js.map